import type { AccessOverviewAction } from './actions';
import type { AccessOverviewState } from './types';
import { initialAccessOverviewState } from './types';

export function accessOverviewReducer(state: AccessOverviewState, action: AccessOverviewAction): AccessOverviewState {
    switch (action.type) {
        case 'LOAD_USER':
            if (state.userId === action.userId && state.firmId === action.firmId && state.phase === 'loading') {
                return state;
            }
            return {
                ...initialAccessOverviewState,
                phase: 'loading',
                userId: action.userId,
                firmId: action.firmId,
            };

        case 'DATA_READY':
            if (state.phase !== 'loading') return state;
            return { ...state, phase: 'ready' };

        case 'DATA_ERROR':
            if (state.phase !== 'loading') return state;
            return { ...state, phase: 'error', error: action.error };

        case 'SELECT_NODE':
            if (state.selectedNodeId === action.nodeId) return state;
            return { ...state, selectedNodeId: action.nodeId };

        case 'SET_SEARCH_QUERY':
            if (state.searchQuery === action.query) return state;
            return { ...state, searchQuery: action.query };

        case 'SET_ACTIVE_TAB':
            if (state.activeTab === action.tab) return state;
            return { ...state, activeTab: action.tab };

        default: {
            const _exhaustiveCheck: never = action;
            return state;
        }
    }
}
